import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';
import { CartesianGrid, Legend, Line, LineChart, ReferenceArea, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts';
const data = [{
  name: 'Episode 1',
  retention: 96,
  interactivity: 5
}, {
  name: 'Episode 2',
  retention: 78,
  interactivity: 15
}, {
  name: 'Episode 3',
  retention: 68,
  interactivity: 40
}, {
  name: 'Episode 4',
  retention: 64,
  interactivity: 65
}, {
  name: 'Episode 5',
  retention: 60,
  interactivity: 85
}];
export function CommitmentCurveScreen() {
  const reduceMotion = useReducedMotion();
  return <section className="flex min-h-screen items-center bg-secondary px-6 py-20 text-white" aria-labelledby="curve-title" data-id="element-155" data-mp="1j6plvraypfbi">
      <div className="mx-auto grid w-full max-w-7xl gap-12 lg:grid-cols-[0.68fr_1.32fr] lg:items-center" data-id="element-156" data-mp="1f6nhhadue7sj">
        <div data-id="element-157" data-mp="1a57xzmrbc9c9">
          <p className="mb-4 text-sm font-semibold text-primary" data-id="element-158" data-mp="1a5zq2nlpboxs">04 - Measuring momentum</p>
          <h2 id="curve-title" className="text-4xl font-bold leading-tight md:text-6xl" data-id="element-159" data-mp="157yc2h34uft6">Find friction before users do</h2>
          <p className="mt-6 max-w-lg text-lg leading-relaxed text-white/65" data-id="element-160" data-mp="3wur3udvp7dx">Retention and interactivity are tracked at every episode so drop-off points are visible, not assumed.</p>
          <div className="mt-10 border-l-2 border-abbvie-cyan pl-5" data-id="element-161" data-mp="3r583cot15o2e">
            <p className="font-semibold" data-id="element-162" data-mp="3w1yin9x0gfmr">Friction point</p>
            <p className="mt-1 text-sm text-white/55" data-id="element-163" data-mp="3w0dty0xdnqwt">Episodes 2-3 are where interactivity should increase most carefully.</p>
          </div>
        </div>

        <motion.div initial={reduceMotion ? false : {
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.28,
        ease: [0.23, 1, 0.32, 1]
      }} className="h-[440px] rounded-2xl bg-white p-5 text-slate-900 shadow-2xl md:h-[520px] md:p-8" data-id="element-164" data-mp="rn8lvsnulkc7">
          <ResponsiveContainer width="100%" height="100%" data-id="element-165" data-mp="33e2syp5uznzh">
            <LineChart data={data} margin={{
            top: 24,
            right: 20,
            left: 0,
            bottom: 20
          }} data-id="element-166" data-mp="33fnke5wvmqt4">
              <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#e2e8f0" data-id="element-167" data-mp="2jaohk8wjdd36" />
              <XAxis dataKey="name" axisLine={false} tickLine={false} tick={{
              fill: '#64748b',
              fontSize: 12,
              fontWeight: 600
            }} dy={10} data-id="element-168" data-mp="2fbfnt41hxf7m" />
              <YAxis hide domain={[0, 100]} data-id="element-169" data-mp="2ahjs688pg4fm" />
              <Tooltip contentStyle={{
              borderRadius: 8,
              border: '1px solid #e2e8f0',
              boxShadow: '0 8px 24px rgb(15 23 42 / 0.08)'
            }} data-id="element-170" data-mp="25lcvz76427av" />
              <Legend verticalAlign="top" height={40} iconType="circle" data-id="element-171" data-mp="20n1lcu7zrsrl" />
              <ReferenceArea x1="Episode 2" x2="Episode 3" fill="var(--abbvie-cyan)" fillOpacity={0.1} data-id="element-172" data-mp="1vlc95b91991x" />
              <Line type="monotone" name="Audience retained" dataKey="retention" stroke="var(--abbvie-pro)" strokeWidth={4} dot={{
              r: 5,
              fill: 'var(--abbvie-pro)',
              strokeWidth: 2,
              stroke: '#fff'
            }} isAnimationActive={!reduceMotion} animationDuration={300} data-id="element-173" data-mp="1rltn2c5h6rxi" />
              <Line type="monotone" name="Interactivity introduced" dataKey="interactivity" stroke="var(--abbvie-cyan)" strokeWidth={4} dot={{
              r: 5,
              fill: 'var(--abbvie-cyan)',
              strokeWidth: 2,
              stroke: '#fff'
            }} isAnimationActive={!reduceMotion} animationDuration={300} data-id="element-174" data-mp="3gzqdlua9tqig" />
            </LineChart>
          </ResponsiveContainer>
        </motion.div>
      </div>
    </section>;
}